import { render, staticRenderFns } from "./DuixiangTable.vue?vue&type=template&id=2b4c813c&"
import script from "./DuixiangTable.vue?vue&type=script&lang=js&"
export * from "./DuixiangTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DuixiangTable.vue"
export default component.exports